import { useTheme } from "../contexts/ThemeContext";

type Props = {
  children: React.ReactNode;
  tone?: "muted" | "error";
};

/**
 * Message centré occupant la zone de contenu. Sert d'état de chargement / d'erreur /
 * de vide sur les pages qui consomment des useQuery, pour un rendu homogène.
 */
export function CenteredMessage({ children, tone = "muted" }: Props) {
  const { t } = useTheme();
  return (
    <div style={{
      flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
      padding: 40, textAlign: "center", fontSize: 14,
      color: tone === "error" ? t.lateColor : t.text2,
    }}>{children}</div>
  );
}
